import { render, staticRenderFns } from "./directReferralEhrform.vue?vue&type=template&id=515d93d4&scoped=true"
import script from "./directReferralEhrform.vue?vue&type=script&lang=js"
export * from "./directReferralEhrform.vue?vue&type=script&lang=js"
import style0 from "./directReferralEhrform.vue?vue&type=style&index=0&id=515d93d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d93d4",
  null
  
)

export default component.exports